'use client';

import { HubNewsItem } from '@/types/hubs';
import HubNewsHubHeader from '@/(routers)/hubs/cases/components/HubNewsHubHeader';
import HubNewsList from '@/(routers)/hubs/cases/components/HubNewsList';

export interface HubNewsHubViewProps {
    hubNews: HubNewsItem;
    hubNewsList: HubNewsItem[];
    variant: 'page' | 'slide';
    onBack?: () => void;
}

export default function HubNewsHubView({ hubNews, hubNewsList, variant, onBack }: HubNewsHubViewProps) {
    if (variant === 'slide') {
        return (
            <div className="flex flex-col w-full h-full overflow-y-auto bg-color-white-base">
                <div className="flex flex-col w-full bg-color-white-base px-5 md:px-8 pt-6 pb-5">
                    <HubNewsHubHeader
                        hubNews={hubNews}
                        hubNewsCount={hubNewsList.length}
                        copyUrl={`/hubs/cases?hub=${encodeURIComponent(hubNews.hub_index)}`}
                    />
                </div>
                <div className="flex flex-col flex-grow w-full sm:px-2 md:px-4 py-6">
                    <HubNewsList hubNewsList={hubNewsList} columns="slide" bordered />
                </div>
            </div>
        );
    }

    return (
        <>
            <div className="flex justify-center w-full py-2">
                <div className="flex flex-col w-full sm:w-[98%] rounded-none sm:rounded-xl bg-color-white-base px-2 sm:px-8 pt-4 pb-6">
                    <HubNewsHubHeader
                        hubNews={hubNews}
                        hubNewsCount={hubNewsList.length}
                        onBack={onBack}
                        copyUrl={`/hubs/cases?hub=${encodeURIComponent(hubNews.hub_index)}`}
                    />
                </div>
            </div>
            <div className="flex justify-center w-full py-4">
                <div className="flex flex-col w-full sm:w-[98%]">
                    <div className="flex justify-center items-center w-full py-4">
                        <HubNewsList hubNewsList={hubNewsList} columns="page" />
                    </div>
                </div>
            </div>
        </>
    );
}
